import { StepAction } from './stepAction';
import type { WheelStep } from 'clickim/src/common/models/wheelStep';
import type { MouseStep } from 'clickim/src/common/models/mouseStep';

export class WheelStepAction extends StepAction<WheelStep> {
    override async performAction() {
        const { step, context } = this;
        const { events, modifiers, button } = step as any as MouseStep;

        if (!events?.length) {
            return undefined;
        }

        const eventMessage = {
            events,
            eventData: {
                modifiers,
                button,
            },
            locatedElement: this.getTarget().locatedElement,
        };

        const timeout = context.data.timeToPlayStep! + 3000;
        const { wheel: wheelScript } = await import('./scripts/wheel');

        const wheelCode = `
            var getLocatedElement = ${this.sessionPlayerInit.codeSnippets.getLocatedElementCode};
            var wheel = ${wheelScript.toString()};
            var eventData = arguments[0];
            var done = arguments[1];
            return wheel.call(null, eventData, done);
        `;

        const result = await this.driver.executeCodeAsync(wheelCode, timeout, eventMessage);
        return { success: result.value?.state === 'success' };
    }
}
